export const ADD_MESSAGE = "ADD_MESSAGE";
export const SET_SHOW_WELCOME_TEXT = "SET_SHOW_WELCOME_TEXT";
export const SET_IS_TYPING = "SET_IS_TYPING";
export const SET_ACTIVE_CHAT = "SET_ACTIVE_CHAT";
export const UPDATE_CHAT = "UPDATE_CHAT";
export const UPDATE_QUESTIONID = "UPDATE_QUESTIONID";
export const SET_ACTIVE_QUESTION = "SET_ACTIVE_QUESTION";
export const SET_FEEDBACK = "SET_FEEDBACK";
export const SET_IS_ARCHIVED = "SET_IS_ARCHIVED";

export const addMessage = (message: any) => ({
  type: ADD_MESSAGE,
  payload: message,
});
export const updateMessage = (message: any) => ({
  type: UPDATE_CHAT,
  payload: message,
});
export const setShowWelcomeText = (value: boolean) => ({
  type: SET_SHOW_WELCOME_TEXT,
  payload: value,
});

export const setIsTyping = (value: boolean) => ({
  type: SET_IS_TYPING,
  payload: value,
});

export const updateQuestionId = (questionId: any) => ({
  type: UPDATE_QUESTIONID,
  payload: questionId,
});
export const setActiveChat = (chatId: String) => ({
  type: SET_ACTIVE_CHAT,
  payload: chatId,
});

export const setActiveQuestion = (chatId: string, questionId: String) => ({
  type: SET_ACTIVE_QUESTION,
  payload: { chatId, questionId },
});

export const setFeedback = ({
  chatId,
  questionId,
  answerId,
  feedback,
}: {
  chatId: string;
  questionId: string;
  answerId: string;
  feedback: any;
}) => ({
  type: SET_FEEDBACK,
  payload: { chatId, questionId, answerId, feedback },
});
export const clearMessages = () => ({
  type: "CLEAR_MESSAGES",
});

export const setIsArchived = (value: boolean) => ({
  type: SET_IS_ARCHIVED,
  payload: value,
});
